// extracted by mini-css-extract-plugin
export default {"component":"MarketOverlayBottom_component__uzYR4","buttonContainer":"MarketOverlayBottom_buttonContainer__j6smW","leftButtons":"MarketOverlayBottom_leftButtons__bY4Ur"};